import { ICurrency } from "models/local/ILocalConfig";

export const moneyMask = (text: string) => {
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    var value = text ? Number.parseInt(text.substr(0, 14).replace(/[^0-9]/g, "")).toString() : "0,00"
    var returnValue: string = value.length > 2 ? value.slice(0, value.length - 2) + "," + value.slice(value.length - 2, value.length) : value.length === 2 ? "0," + value : "0,0" + value
    return (currency?.symbol ?? "R$") + returnValue
}
export const moneyMaskNumber = (money: number) => {
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    return money.toLocaleString('pt-br', { style: 'currency', currency: currency?.code ?? 'BRL' })
}

export const moneyToFloat = (text: string) => {
    return Number.parseFloat(text.replace(/[^0-9]/g, "")) / 100;
}